import "jquery/dist/jquery.min.js";
import Axios from "axios";
import $ from "jquery";
import EditForm from "@/pages/assets/editasset/editasset.vue";
import MarkAsBeingRepaired from "@/pages/vehicles/markasbeingrepaired/markasbeingrepaired.vue";
import VueGallery from "vue-gallery";
import DriverProfilePicture from "@/pages/drivers/driverprofilepicture/driverprofilepicture";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import AssetChecks from "@/pages/assets/assetchecks/assetchecks.vue";
import DeleteImage from '@/pages/operations/deleteimage/deleteimage';
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
import VehicleDocuments from "@/pages/vehicles/vehicledocuments/vehicledocuments.vue";
import VehicleServiceHistory from "@/pages/vehicles/vehicleservicehistory/vehicleservicehistory.vue";
import QrCode from "@/pages/assets/qrcode/qrcode.vue";
import AddNotes from '@/pages/drivers/addnotes/addnotes';
import Notes from '@/pages/drivers/notes/notes';
import Task from "@/pages/task/task";
import Swiper, {navigation} from 'swiper';
import AuditLogs from '@/pages/auditlog/auditlogdata/auditlogdata.vue';
import VehicleMaps from '@/pages/vehicles/vehiclemaps/vehiclemaps.vue';
import AssetTrips from '@/pages/assets/assettrips/assettrips.vue';

import StatusButton from '@/components/StatusButton.vue';

var moment = require("moment");
export default {
  components: {
    EditForm,
    MarkAsBeingRepaired,
    VueGallery,
    DriverProfilePicture,
    UpcomingEvent,
    AssetChecks,
    DeleteImage,
    DocumentPopup,
    VehicleDocuments,
    VehicleServiceHistory,
    QrCode,
    AddNotes,
    Notes,
    Task,
    AuditLogs,
    VehicleMaps,
    AssetTrips,
    StatusButton
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
    },
    date_time: function (data) {
      var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY h:mm A");
        }
        return sendDate;
    }
  },
  data() {
    return {
      trackingModule: false, 
      ShowVehiclePositionModel: false,	
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      CompanyData:"",
      PopupLoader: false,
      ShowLoader: false,
      submitted: false,
      AssetId: 0,
      editForm: false,
      SaveData: false,
      ShowDocuments:false,
      fromDate: "",
      toDate: "",
      vrm: "",
      VehicleNotes: "",
      VehicleChecks: [],
      NewAsset: {
        additional_photos:[],
        assignments:[],
      },
      AssginVehicle: { asset_id: 0, vehicle_id: 0 },
      file: "",
      SearchData: false,
      gindex: 1,
      AccountPermissions:[],
      ShowAssetAssignVehicle:false,
      ShowAssetEdit:false,
      ShowAssetDelete:false,
      ShowUrgentTask:false,
      ShowVehicleChecks:false,
      DocumentPopupSubCategory:false,
      DocumentPopupCategory:"",
      FleetSubscription:[],
      ShowAssetImagePopup:false,
      AssetImage:"",
      ownership_link_export_data: [],
      ownership_links: [],
      infoOpened: false,
      showLocationDetails: false,
      locationPoints: "",
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
      AssetLastPosition:"",
      GetCurrentPositionInterval: null,


    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
      );
      this.AccountPermissions = AccountPermissions;

      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)){
      this.$router.push('/');
    }

    if (this.AccountPermissions && 
      this.AccountPermissions.Assets &&
      this.AccountPermissions.Assets.enable) {
      if ( this.AccountPermissions.Assets.edit) {
        this.ShowAssetEdit = true;
      }
      if ( this.AccountPermissions.Assets.delete) {
        this.ShowAssetDelete = true;
      }
    }
    
    if (AccountPermissions && 
      AccountPermissions['Vehicle Checks'] &&
      AccountPermissions['Vehicle Checks']['enable']) {
        this.ShowVehicleChecks = true;
        if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
          this.ShowUrgentTask = true;
        }
    }

    if (this.AccountPermissions && 
      this.AccountPermissions.Documents &&
      this.AccountPermissions.Documents.enable) {
        this.ShowDocuments = true;
      }

    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowAssetEdit = true;
      this.ShowAssetDelete = true;
      this.ShowUrgentTask = true;
      this.ShowVehicleChecks = true;
      this.ShowDocuments = true;
    }

    this.CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (this.CompanyData && this.CompanyData.name) {            
      if (
        Array.isArray(window.taskModuleCompanies) &&
        window.taskModuleCompanies.includes(this.CompanyData.id)
      ) {
        this.todaysUrgentTaskNew = true;
      }
    } 

    var FleetSubscriptionModules = JSON.parse(JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules);	
    const isTracking = FleetSubscriptionModules["Assets Tracking"];
    if (isTracking) {
    	this.trackingModule = true;
    }
 
    this.AssetId = this.$route.params.AssetId;
    setTimeout(() => {
      this.GetAssetDetail();
      this.GetAssetOwnershipDetail();
    }, 1000);

    this.$root.$on("ShowLocationMaps",(Details) => {
      if(typeof Details != 'undefined'){
        this.ShowLocationMap(Details);
      }
    });

    this.GetCurrentPositionInterval = setInterval(() => {
      this.GetCurrentPosition();
    }, 300000);
  },
 beforeUnmount() {
    clearInterval(this.GetCurrentPositionInterval);
  },
  methods: {
    GetCurrentPosition() {
          if((this.NewAsset?.inseego_node_id && this.NewAsset.inseego_node_id > 0) || (this.NewAsset?.serial_number && this.NewAsset.serial_number != "")){
            var obj = { token: localStorage.getItem("token") };
            obj.inseego_node_id = this.NewAsset.inseego_node_id;   
            obj.vrm = this.NewAsset.serial_number;   
            Axios.post(Endpoints.Tracking.GetCurrentPosition, obj).then((Response) => {
              if (Response?.data?.success) {
                this.AssetLastPosition = Response.data.position;          
              }
            });
          }
        }, 
    ShowLocationMap(Details) {
      this.showLocationDetails = true;
      if(!Details?.latitude || !Details?.longitude){
        return;
      }
      const marker = {
        lat: parseFloat(Details.latitude),
        lng: parseFloat(Details.longitude),
      };
      this.center = marker,
      this.locationPoints = marker;
      this.infoOpened = true;
      this.infoOptions.content =
        '<div id="mapcontent"><h5 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
        (this.NewAsset?.name || '') +
        "</h5></div>";
    },
    ShowAssetsPosition(){
    	this.ShowVehiclePositionModel = true;
    	setTimeout(() => {
    		this.$refs.VehicleMaps.ShowVehicleMaps()
    	},500);
    },
    AddNote(){
      this.$refs.add_notes_section.NewNoteOpen();
    },
    LoadNotesData(){
			this.$refs.notes_section.GetNotesList();
		},
    ShowAssetImage(AssetImage){
      this.AssetImage =  "";
      this.ShowAssetImagePopup = true;
      this.AssetImage = this.ImageEndpoint+AssetImage;
    },
    AddDocument(type = "") {
      var heading = '';
      if(type == 'service'){
        heading = 'Service';
      }
      var category = "vehicle";
      this.NewDocument={};
      this.DocumentPopupCategory = category;
      this.DocumentPopupSubCategory = type;
      this.$refs.popup.loadPopupModal(type,heading);
    },
    
    LoadProfileData(){
		this.GetAssetDetail();
	},
    EditDocument(document) {
      this.$refs.popup.loadEditData(document);
    },
    DeleteDocument(document_id) {
      this.$refs.popup.DeleteDocumentData(document_id);
    },
    LoadHistory() {
      this.$refs.asset_history.GetVehicleServices();
      this.$refs.asset_document.GetDocumentList();
    },
    GetAssetDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.Get, {
        token: localStorage.getItem("token"),
        Assets_id: this.AssetId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.NewAsset = Response.data.record;
         if (
            this.NewAsset.additional_photos &&
            typeof this.NewAsset.additional_photos === "string"
          ) {
            try {
              this.NewAsset.additional_photos = JSON.parse(this.NewAsset.additional_photos);
            } catch (e) {
              this.NewAsset.additional_photos = [];
            }
          } else if (!Array.isArray(this.NewAsset.additional_photos)) {
            this.NewAsset.additional_photos = [];
          }

          setTimeout(() => {
						new Swiper('.swiper', {
							// Optional parameters
							direction: 'horizontal',
							loop: this.vehicleLoop,
							// Navigation arrows
							navigation: {
							  nextEl: '.swiper-button-next',
							  prevEl: '.swiper-button-prev',
							},
						  });
					}, 1000);

          this.GetCurrentPosition();

        }else{
          this.$router.push("/error-404");
        }
      });
    },
    GetAssetOwnershipDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.DriverOwnershipLink, {
        token: localStorage.getItem("token"),
        assets_id: this.AssetId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.ownership_links = Response.data.records;
          this.ownership_link_export_data = [];
          if (Array.isArray(this.ownership_links) && this.ownership_links.length > 0) {
            this.ownership_links.forEach((element) => {
              var obj = {};
              obj["Asset"] = this.NewAsset.name;
              obj["Group"] = element.group_name;
              obj["Driver"] = element.forename +' '+element.surname;
              obj["Date"] = element.created_at;
              this.ownership_link_export_data.push(obj);
            });
          }

        }
      });
    },
    DeleteAsset(asset_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to delete this Asset?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Assets.Delete, {
              token: localStorage.getItem("token"),
              id: asset_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.$router.push("/assets/list");
                this.$swal
                  .fire("Asset Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },   
  },
};
